import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { getRightworkAPI } from "../requests/utilities/requests";
import { API_get_maintenance_comments } from "../../../constants";

function MaintenanceCommentTooltip(props) {
  const { ticketUuid, homeStore, commentCount } = props;

  const [comments, setComments] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Invalidate cache when comment count changes
  useEffect(() => {
    setComments(null);
  }, [commentCount]);

  const fetchComments = async () => {
    if (comments !== null || isLoading) return;
    setIsLoading(true);
    try {
      const res = await getRightworkAPI(API_get_maintenance_comments, {
        store_id: homeStore,
        maintenance_request_uuid: ticketUuid,
      });
      setComments(res.data?.redux?.payload?.maintenance_comments || []);
    } catch (error) {
      // Leave as null so next hover retries
    } finally {
      setIsLoading(false);
    }
  };

  if (!commentCount || commentCount === 0) return null;

  const tooltipContent = (
    <div>
      <h4 className="text-slate-700 text-sm font-bold mb-3">COMMENTS</h4>
      {isLoading ? (
        <div className="flex items-center justify-center py-4">
          <CircularProgress size={20} sx={{ color: "#6d28d9" }} />
        </div>
      ) : !comments || comments.length === 0 ? (
        <p className="text-xs text-slate-500">No comments yet</p>
      ) : (
        <div className="space-y-4">
          {comments.map((comment) => (
            <div key={comment.uuid} className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-full bg-violet-100 text-violet-700 flex items-center justify-center flex-shrink-0" style={{ fontSize: "10px", fontWeight: 600 }}>
                {comment.author?.initials || "?"}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-xs font-medium text-slate-900">
                    {comment.author?.full_name}
                  </p>
                  <p className="text-xxs text-slate-400">
                    {comment.created_at_formatted}
                  </p>
                </div>
                <p className="text-xs text-slate-700 mt-0.5" style={{ whiteSpace: "pre-wrap" }}>
                  {comment.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <Tooltip
      title={tooltipContent}
      onOpen={fetchComments}
      componentsProps={{
        tooltip: {
          sx: {
            maxHeight: "500px",
            overflow: "auto",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            boxShadow:
              "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            border: "1px solid #e2e8f0",
            color: "inherit",
            width: "350px",
          },
        },
      }}
    >
      <ChatOutlinedIcon
        className="text-slate-400 hover:text-violet-700 cursor-pointer transition-colors"
        style={{ fontSize: "16px" }}
      />
    </Tooltip>
  );
}

export default MaintenanceCommentTooltip;
